module.exports = __webpack_public_path__ + "img/seller-mobile.a47cc06d.jpg";